import React from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { Box, Button, Flex, Loading, Message, Text, toast } from '@workwhile/ui'
import { Plus, Trash } from 'lucide-react'
import { ButtonWithConfirmation } from 'pages/Dayforce/shared/components/ButtonWithConfirmation'
import { useCustomShiftNotificationsContextValue } from '../context/CustomShiftNotificationsProvider'
import { formatDeliveryHour } from '../utils/formatDeliveryHour'

export const CustomShiftNotificationsMain = () => {
  const {
    state: {
      notifications,
      isPending,
      isError,
      deleteMutationState: { isPending: isDeletePending },
    },
    actions: { refetch, openCreate, remove },
  } = useCustomShiftNotificationsContextValue()

  return (
    <AccordionCard
      isAccordion
      defaultOpen={false}
      title={
        <Flex justifyContent="space-between" alignItems="center" gap={2}>
          <Text fontSize={2} color="lightText">
            Shift Notifications
          </Text>
          <Button
            kind="small"
            variant="primary"
            onClick={(event) => {
              event.stopPropagation()
              openCreate()
            }}
          >
            <Flex as="span" alignItems="center" style={{ gap: 6 }}>
              <Plus size={14} />
              Add
            </Flex>
          </Button>
        </Flex>
      }
    >
      {isPending ? <Loading /> : null}
      {isError ? (
        <Message variant="error" borderRadius="small">
          Failed to load shift notifications.{' '}
          <Button kind="small" variant="text" onClick={() => refetch()}>
            Retry
          </Button>
        </Message>
      ) : null}
      {!isPending && !isError && notifications.length === 0 ? (
        <Text fontSize={1} color="lightText">
          Add a custom SMS/push reminder for workers on this shift.
        </Text>
      ) : null}
      {!isPending && !isError
        ? notifications.map((notification, index) => (
            <Box
              key={notification.id}
              border="1px solid"
              borderColor="neutrals.100"
              borderRadius="standard"
              p={3}
              mb={index === notifications.length - 1 ? 0 : 3}
            >
              <Flex
                justifyContent="space-between"
                alignItems="flex-start"
                gap={2}
              >
                <Box>
                  <Text fontSize={1} color="lightText">
                    {formatDeliveryHour(notification.deliveryHour)}
                  </Text>
                  {notification.title ? (
                    <Text fontSize={2} mt={1} fontWeight="500">
                      {notification.title}
                    </Text>
                  ) : null}
                  <Text fontSize={2} mt={1}>
                    {notification.message}
                  </Text>
                </Box>
                <ButtonWithConfirmation
                  message={`Remove shift notification ${notification.title}?`}
                  onClick={() => {
                    remove(notification.id, {
                      onSuccess: () => {
                        toast.success('Shift notification removed')
                      },
                      onError: (error) => {
                        toast.error(
                          error.message || 'Failed to remove shift notification'
                        )
                      },
                    })
                  }}
                  variant="text"
                  kind="small"
                  title="Remove notification"
                  danger
                  disabled={isDeletePending}
                >
                  <Trash size={16} />
                </ButtonWithConfirmation>
              </Flex>
            </Box>
          ))
        : null}
    </AccordionCard>
  )
}
